import { DIET_ROUTES } from '../constants/routes';

export const DIET_ROUTE_ACCESS = {
  [DIET_ROUTES.RECIPES_LIST]: { departments: ['Nutritionist', 'Diet'], roles: [] },
  [DIET_ROUTES.RECIPES_DETAIL]: { departments: ['Nutritionist', 'Diet'], roles: [] },
  [DIET_ROUTES.RECIPES_NEW]: { departments: ['Nutritionist', 'Diet'], roles: [] },
  // Nutritionist Coaches and Managers both work with templates and plans.
  [DIET_ROUTES.TEMPLATES_LIST]: { departments: ['Nutritionist', 'Diet'], roles: ['Manager', 'Lead Coach', 'Coach', 'Diet Coach'] },
  [DIET_ROUTES.TEMPLATES_NEW]: { departments: ['Nutritionist', 'Diet'], roles: ['Manager', 'Lead Coach', 'Coach', 'Diet Coach'] },
  [DIET_ROUTES.TEMPLATES_DETAIL]: { departments: ['Nutritionist', 'Diet'], roles: ['Manager', 'Lead Coach', 'Coach', 'Diet Coach'] },
  [DIET_ROUTES.PLANS_EDITOR]: { departments: ['Nutritionist', 'Diet'], roles: ['Manager', 'Lead Coach', 'Coach', 'Diet Coach'] },
  // Reference data is Nutritionist Manager only (Executive passes every check).
  [DIET_ROUTES.DIET_REFERENCE_DATA]: { departments: ['Nutritionist', 'Diet'], roles: ['Manager'] },
};

export const DIET_BUTTON_PERMISSIONS = {};

export const PLAN_EDIT_ACCESS_SOURCES = [
  DIET_ROUTES.RECIPES_LIST,
  DIET_ROUTES.TEMPLATES_LIST,
];

const UUID_SEGMENT =
  /\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/gi;

function normalizeDietPath(path) {
  if (!path) return path;
  return path.replace(UUID_SEGMENT, '/:id');
}

function isPlanEditTarget(route) {
  const normalized = normalizeDietPath(route);
  return (
    normalized === DIET_ROUTES.PLANS_EDITOR ||
    normalized === DIET_ROUTES.TEMPLATES_DETAIL ||
    normalized === DIET_ROUTES.TEMPLATES_NEW ||
    route === DIET_ROUTES.PLANS_EDITOR ||
    (route?.startsWith(`${DIET_ROUTES.TEMPLATES_LIST}/`) && route !== DIET_ROUTES.TEMPLATES_NEW)
  );
}

export function evaluateDietRouteGrant(route, departments, roles, getRules, passesRules) {
  if (!isPlanEditTarget(route)) return false;
  return PLAN_EDIT_ACCESS_SOURCES.some((sourceRoute) => {
    const rules = getRules(sourceRoute);
    return passesRules(rules, departments, roles);
  });
}

/** Diet feature access — registered in configs/featureAccess. */
export const dietAccess = {
  id: 'diet',
  routes: DIET_ROUTE_ACCESS,
  buttons: DIET_BUTTON_PERMISSIONS,
  tryGrantRoute(route, { departments, roles, getRules, passesRules }) {
    return evaluateDietRouteGrant(route, departments, roles, getRules, passesRules);
  },
};
